module.exports = __webpack_public_path__ + "static/media/confetti.8f4754c7.svg";